import React, { useRef } from 'react';
import styled from 'styled-components';
import { LinkedBanners } from '../../../redux/seo/types';
import useUserTracking from '../../../hooks/flags/useUserTracking';
import Banner from '../../Generic/Banner';
import useGa from '../../../hooks/useGa';
import useFeatureToggle from 'Client/hooks/useFeatureToggle';

const StyledContainer = styled.div`
    padding: 20px 10px;
`;

const newBannerUrlKeys = new Set([
    'textilien-und-teppiche',
    'teppiche',
    'eckige-teppiche',
    'flachgewebte-teppiche',
    'kurzflor-teppiche',
    'hochflor-teppiche',
    'jute-teppiche',
    'einfarbige-teppiche',
    'vintage-teppiche',
    'berber-teppiche',
    'eckige-outdoor-teppiche',
    'design-teppiche',
    'kelim-orientteppiche',
    'runde-teppiche',
    'teppichlaeufer',
    'fussmatten',
    'fellteppiche',
    'vinylmatten',
    'baby-kinderteppiche',
]);

const newBanner = {
    bannerLink:
        'https://www.westwing.de/c-aa01/c-unsere-bestseller-teppiche/?tc=retg-rugs-int&pr=fetch&utm_source=shop&utm_medium=referral&utm_campaign=shop2club-footer-banner-PLP-mood',
    bannerImage:
        'https://static.westwingnow.de/cms/21Q1%20S2C%20AB%20Test/PCM-219_MarketingTechnology_LPBanners_TCRugs_DE_mobile.jpg',
    desktopBannerImage:
        'https://static.westwingnow.de/cms/21Q1%20S2C%20AB%20Test/PCM-219_MarketingTechnology_LPBanners_TCRugs_DE_desktop.jpg',
};

interface Props {
    shopToClubFooterBanners: LinkedBanners[];
    isFullWidthBanner?: boolean;
    listingPageKey?: string;
}

const ShopToClubBanner: React.SFC<Props> = ({ shopToClubFooterBanners = [], listingPageKey = '' }) => {
    const { isRegistered } = useUserTracking();
    const bannerRef = useRef<HTMLDivElement>(null);
    const gaTracker = useGa();
    const { p100ShowNewS2CBanner } = useFeatureToggle();

    return !isRegistered ? (
        <StyledContainer ref={bannerRef}>
            {p100ShowNewS2CBanner && newBannerUrlKeys.has(listingPageKey) ? (
                <Banner
                    key={newBanner.bannerLink}
                    shouldLazyLoadBanner
                    targetUrl={newBanner.bannerLink}
                    mobileImage={newBanner.bannerImage}
                    desktopImage={newBanner.desktopBannerImage}
                    trackImpressionFunction={() => {
                        gaTracker.shopToClub.trackProductListingBannerImpression(newBanner.bannerLink);
                    }}
                    trackingFn={() => {
                        gaTracker.shopToClub.trackProductListingBannerClick(newBanner.bannerLink);
                    }}
                />
            ) : (
                shopToClubFooterBanners.map(banner => {
                    return (
                        <Banner
                            key={banner.bannerLink}
                            shouldLazyLoadBanner
                            targetUrl={banner.bannerLink}
                            mobileImage={banner.bannerImage}
                            desktopImage={banner.desktopBannerImage}
                            trackImpressionFunction={() => {
                                gaTracker.shopToClub.trackProductListingBannerImpression(banner.bannerLink);
                            }}
                            trackingFn={() => {
                                gaTracker.shopToClub.trackProductListingBannerClick(banner.bannerLink);
                            }}
                        />
                    );
                })
            )}
        </StyledContainer>
    ) : (
        <></>
    );
};

export default ShopToClubBanner;
